import { whatsappLink } from '@/lib/public-contact-links.mjs';
import { googleLink } from '@/lib/operational-ui-guards.mjs';

// A local gazetteer, not geocoding, coverage, depot, or vehicle-location data.
export const PLACES = [
  ['Santo Domingo', 18.4749, -69.9395, 13], ['Santiago', 19.4517, -70.697, 13],
  ['San Cristóbal', 18.4167, -70.109, 13], ['Boca Chica', 18.450, -69.607, 14],
  ['Punta Cana', 18.582, -68.405, 12], ['La Romana', 18.427, -68.973, 13],
  ['Puerto Plata', 19.790, -70.690, 13], ['La Vega', 19.222, -70.529, 13],
  ['San Pedro de Macorís', 18.456, -69.307, 13], ['Bávaro', 18.681, -68.446, 13],
  ['Ensanche Naco, Santo Domingo', 18.484, -69.927, 15], ['Piantini, Santo Domingo', 18.476, -69.937, 15],
  ['Zona Colonial, Santo Domingo', 18.474, -69.883, 15], ['Santo Domingo Este', 18.488, -69.846, 13],
  ['Los Alcarrizos', 18.531, -70.003, 13],
].map(([name, lat, lng, zoom]) => ({ name, lat, lng, zoom }));
export const normalizePlace = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
export const searchPlaces = query => PLACES.filter(place => normalizePlace(place.name).includes(normalizePlace(query))).slice(0, 7);
export function phoneLink(value) {
  if (typeof value !== 'string' || !/^[+\d\s().-]{7,30}$/.test(value)) return null;
  const digits = value.replace(/\D/g, '');
  return /^\d{8,15}$/.test(digits) ? `tel:${value.startsWith('+') ? '+' : ''}${digits}` : null;
}
export function emailLink(value) {
  return typeof value === 'string' && /^[^\s@?&#]+@[^\s@?&#]+\.[^\s@?&#]+$/.test(value) && value.length < 255 ? `mailto:${value}` : null;
}
export function safeExternalUrl(value) {
  if (typeof value !== 'string' || value.length > 2048) return null;
  try { const url = new URL(value); return url.protocol === 'https:' && !url.username && !url.password ? url.href : null; } catch { return null; }
}
export function publicContacts(config) {
  const phone = config?.main_phone || config?.phone;
  const baseWhatsApp = whatsappLink(config?.socials?.whatsapp) || whatsappLink(config?.whatsapp_public || config?.whatsapp);
  let whatsapp = baseWhatsApp;
  if (baseWhatsApp) {
    const url = new URL(baseWhatsApp);
    url.searchParams.set('text', typeof config?.whatsapp_default_message === 'string' ? config.whatsapp_default_message.slice(0, 1000) : 'Hola, necesito asistencia de C&A Transporte & Rescate.');
    whatsapp = url.href;
  }
  return { phone: phoneLink(phone), phoneDisplay: typeof config?.display_phone === 'string' ? config.display_phone : (typeof phone === 'string' ? phone : ''), whatsapp, email: emailLink(config?.email) };
}
export function validReputation(value, socials) {
  const rating = value?.rating, count = value?.review_count;
  if (typeof rating !== 'number' || typeof count !== 'number' || !Number.isFinite(rating) || rating <= 0 || rating > 5 || !Number.isInteger(count) || count <= 0 || (value?.enabled !== undefined && value.enabled !== true)) return null;
  return { rating, count, review: googleLink(value?.review_url), business: googleLink(value?.business_url) || googleLink(socials?.google_business) };
}
export const PUBLIC_WEB_ASSETS = `${process.env.PUBLIC_URL || ''}/ca-web-map`;
